import { render, staticRenderFns } from "./SignatureMatchTypeChip.vue?vue&type=template&id=75d1267b"
import script from "./SignatureMatchTypeChip.vue?vue&type=script&lang=ts"
export * from "./SignatureMatchTypeChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports